export const getURLParam = (param: string): string => {
    return new URLSearchParams(window.location.search.slice(1)).get(param) || ''
}
